import { createSlice } from '@reduxjs/toolkit';
import { menuNavigationInterface, NotificationInterface } from '../../types/setting.type';

interface UiState {
  isMenuOpen: boolean;
  isSearchOpen: boolean;
  isLanguageModalOpen: boolean;
  menus: menuNavigationInterface[];
  navbar: menuNavigationInterface[];
  notices: NotificationInterface[];
}

const initialState: UiState = {
  isMenuOpen: false,
  isSearchOpen: false,
  isLanguageModalOpen: false,
  menus: [],
  navbar: [],
  notices: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
    toggleSearch: (state) => {
      state.isSearchOpen = !state.isSearchOpen;
    },
    closeSearch: (state) => {
      state.isSearchOpen = false;
    },
    toggleLanguageModal: (state) => {
      state.isLanguageModalOpen = !state.isLanguageModalOpen;
    },
    closeLanguageModal: (state) => {
      state.isLanguageModalOpen = false;
    },
    setMenus: (state, action) => {
      state.menus = action.payload;
    },
    setNavbar: (state, action) => {
      state.navbar = action.payload;
    },
    setNotices: (state, action) => {
      state.notices = action.payload;
    },
  },
});

export const {
  toggleMenu,
  closeMenu,
  toggleSearch,
  closeSearch,
  toggleLanguageModal,
  closeLanguageModal,
  setMenus,
  setNavbar,
  setNotices,
} = uiSlice.actions;

export default uiSlice.reducer;
